import { Builder, withChildren } from '@builder.io/react';

import { HeroDefault } from 'react-scale/components';

const HeroDefaultWithBuilderChildren = withChildren(HeroDefault)

Builder.registerComponent(HeroDefaultWithBuilderChildren, {
  name: "HeroDefault",
  inputs: [
    {
      name: "bgAnimated",
      type: "boolean",
      defaultValue: true
    },
    {
      name: "overtitle",
      type: "string"
    },
    {
      name: "title",
      type: "string",
      defaultValue: "Scale"
    },
    {
      name: "product",
      type: "string"
    },
    {
      name: "subtitle",
      type: "string"
    },
    {
      name: 'cta',
      type: 'object',
      subFields: [
        {
          name: 'buttons',
          type: 'list',
          subFields: [
            {
              name: 'text',
              type: 'string'
            },
            {
              name: 'href',
              type: 'url'
            },
            {
              name: 'variant',
              type: 'string',
              defaultValue: 'primary',
              enum: ['primary', 'secondary', 'inverted']
            }
          ],
          defaultValue: [
            {
              text: 'Get Started',
              href: '/sales',
              variant: 'primary'
            }
          ]
        },
        {
          name: 'hubspotModal',
          type: 'boolean',
          defaultValue: false
        },
        {
          name: 'hubspotModal',
          type: 'object',
          showIf: `options.get('hubspotModal')`,
          subFields: [
            {
              name: 'formId',
              type: 'string'
            },
            {
              name: 'sfdcCampaignId',
              type: 'string'
            },
            {
              name: 'label',
              type: 'string'
            }
          ]
        },
        {
          name: 'disclaimer',
          type: 'string',
          helperText: 'Disclaimer text'
        }
      ]
    }
  ],
  defaultChildren: [
    { 
      component: {
        name: 'VideoModal'
      }
    }
  ]
});